<script lang="ts">
  import type {
    IEventList,
    IStatWidget,
  } from '../../modules/statwidget/statwidget.interface';
  import { IOperationType } from '../../modules/statwidget/statwidget.interface';
  import type { DataItem, PopularResponse } from '../../lib/pandalytics';
  import { QueryGroup, QueryInterval } from '../../lib/pandalytics';
  import { IStatWidgetType } from '../../modules/statwidget/statwidget.interface';
  import StatWidget from './StatWidget.svelte';
  import { Row, Col } from 'svelte-materialify';
  import { transformKeyToArticleProp } from '../../modules/statwidget/statwidget.transformer';

  export let project: string;

  interface ISelectField {
    value: string;
    name: string;
  }

  const pages: ISelectField[] = [
    {
      value: '1',
      name: 'First Page',
    },
    {
      value: '2',
      name: 'Second Page',
    },
  ];
  let selectedPage: string = pages[0].value;

  const eventList: IEventList[] = [
    { widgetTitle: 'App Init', widgetEvent: 'APP_INIT', fieldTitles: ['Open'] },
    { widgetTitle: 'Bookmark', widgetEvent: 'BOOKMARK_ADD', fieldTitles: ['Bookmark'] },
    { widgetTitle: 'Item Click', widgetEvent: 'ITEM_CLICK', fieldTitles: ['Click'] },
    {
      widgetTitle: 'Scroll Event',
      widgetEvent: 'SCROLL_PERCENTAGE',
      fieldTitles: ['Scroll'],
    },
  ];
  let event = eventList[0];

  function selectedEventFunc(e) {
    event = eventList.find(({ widgetEvent }) => widgetEvent === e.detail);
    statWidgetOptional.query.actions = [event.widgetEvent];
    statWidgetOptional.title = event.widgetTitle;
    statWidgetOptional.fieldTitles = event.fieldTitles;
  }

  const statWidget: IStatWidget = {
    title: 'Install Uninstall Total',
    type: IStatWidgetType.Lines,
    fieldTitles: ['Install', 'Uninstall'],
    lineColors: ['#4067CC', '#EB4747'],
    formatTime: 'D MMM',
    query: {
      project,
      groupBy: QueryGroup.Action,
      actions: ['EXTENSION_INSTALL', 'EXTENSION_UNINSTALL'],
      interval: QueryInterval.Day,
    },
    additionalFields: [
      {
        name: 'Total',
        color: '#1DC25F',
        operation: IOperationType.Difference,
        parameters: [0, 1],
      },
    ],
  };

  const statWidget2: IStatWidget = {
    title: 'New Registered Users',
    type: IStatWidgetType.Lines,
    fieldTitles: ['New Registered User'],
    formatTime: 'D MMM',
    query: {
      project,
      groupBy: QueryGroup.Action,
      actions: ['USER_CREATE'],
      interval: QueryInterval.Day,
    },
  };

  const statWidget3: IStatWidget = {
    title: 'Most clicked urls',
    type: IStatWidgetType.Table,
    query: {
      project,
      groupBy: QueryGroup.Label,
      actions: ['ITEM_CLICK'],
    },
    transformResponse: (response: PopularResponse) =>
      transformKeyToArticleProp(response, 'data', 'url'),
    onClick: (dataItem: DataItem) => {
      window.open(dataItem.key as string, '_blank');
    },
  };

  const statWidget4: IStatWidget = {
    title: 'Most bookmarked categories',
    type: IStatWidgetType.Table,
    query: {
      project,
      groupBy: QueryGroup.Category,
      actions: ['BOOKMARK_ADD'],
    },
  };

  const statWidget5: IStatWidget = {
    title: 'Most clicked categories',
    type: IStatWidgetType.Table,
    query: {
      project,
      groupBy: QueryGroup.Category,
      actions: ['ITEM_CLICK'],
    },
  };

  const statWidget6: IStatWidget = {
    title: 'Report open count by day',
    type: IStatWidgetType.Bars,
    fieldTitles: ['Open'],
    lineColors: ['#4067CC'],
    formatTime: 'D MMM',
    query: {
      project,
      groupBy: QueryGroup.Action,
      actions: ['REPORT_OPEN'],
      interval: QueryInterval.Day,
      // dateField: QueryField.Label,
    },
  };

  const statWidget7: IStatWidget = {
    title: 'Page views',
    type: IStatWidgetType.Table,
    query: {
      project,
      groupBy: QueryGroup.Label,
      actions: ['APP_PAGE_VIEW'],
    },
  };

  const statWidgetOptional: IStatWidget = {
    title: event.widgetTitle,
    type: IStatWidgetType.Bars,
    fieldTitles: event.fieldTitles,
    lineColors: ['#4067CC'],
    formatTime: 'D MMM',
    query: {
      project,
      groupBy: QueryGroup.Action,
      actions: [event.widgetEvent],
      interval: QueryInterval.Day,
    },
    additionalFields: [
      {
        name: '',
        color: '',
        operation: IOperationType.Summation,
        parameters: [0],
      },
    ],
  };

  const statWidget8: IStatWidget = {
    title: 'Most clicked reader sources',
    type: IStatWidgetType.Table,
    query: {
      project,
      groupBy: QueryGroup.Category,
      actions: ['READER_ITEM_OPEN'],
    },
  };

  const statWidget9: IStatWidget = {
    title: 'Most clicked library sources',
    type: IStatWidgetType.Table,
    query: {
      project,
      groupBy: QueryGroup.Category,
      actions: ['LIBRARY_ITEM_OPEN'],
    },
  };

  const statWidget10: IStatWidget = {
    title: 'Active Users',
    type: IStatWidgetType.Chart,
    query: {
      project,
      groupBy: QueryGroup.Label,
      actions: [''],
    },
  };

  const statWidget11: IStatWidget = {
    title: 'Most clicked product urls weekly',
    type: IStatWidgetType.Table,
    query: {
      project,
      groupBy: QueryGroup.Label,
      actions: ['ITEM_CLICK'],
    },
    transformResponse: (response: PopularResponse) =>
      transformKeyToArticleProp(response, 'data', 'url'),
    onClick: (dataItem: DataItem) => {
      window.open(dataItem.key as string, '_blank');
    },
  };

  const statWidget12: IStatWidget = {
    title: 'Registered and guest users',
    type: IStatWidgetType.Chart,
    query: {
      project,
      actions: ['APP_PAGE_VIEW'],
    },
  };

  const firstStatWidgets = [
    statWidget3,
    statWidget4,
    statWidget5,
    statWidget7,
    statWidget8,
    statWidget9,
    statWidget11,
  ];
  const secondStatWidgets = [statWidget, statWidget2, statWidget10, statWidget12];
</script>

<Row>
  {#each pages as page}
    <button
      class="day-select"
      class:active={selectedPage === page.value}
      on:click={() => {
        selectedPage = page.value;
      }}>{page.name}</button
    >
  {/each}
  {#if selectedPage === '1'}
    <Col cols={12}>
      <StatWidget widget={statWidget6} />
    </Col>
    {#each firstStatWidgets as statWidget}
      <Col cols={6}>
        <StatWidget widget={statWidget} />
      </Col>
    {/each}{:else}
    <Col cols={12}>
      <StatWidget widget={statWidgetOptional} on:select-event={selectedEventFunc} />
    </Col>
    {#each secondStatWidgets as statWidget}
      <Col cols={6}>
        <StatWidget widget={statWidget} />
      </Col>
    {/each}
  {/if}
</Row>

<style lang="scss">
  .day-select {
    margin: 5px;
    margin-left: 13px;
    background-color: #dcdcdc;
    border-radius: 5px;
    padding: 2px 8px;
    &.active {
      color: #fff;
      background-color: #4067cc;
    }
  }
</style>
